import React from 'react';
import { twJoin } from 'tailwind-merge';
import { ComparisonRowProps } from './types/ComparisonRowProps';

export default function ComparisonRow({ children, productsLength }: ComparisonRowProps) {
  return (
    <div
      className={twJoin(
        'grid gap-2 sm:gap-3',
        productsLength === 2 ? 'grid-cols-2 sm:grid-cols-3' : 'grid-cols-3 sm:grid-cols-4',
      )}
    >
      {children}
    </div>
  );
}
